<template>
    <div class="sw-login">
      <div class="sw-login-wrap">
        <el-container style="width: 100%;height: 100%;">

          <!-- background -->
          <div id="background" style="width: 100%;height: 100%;"></div>

          <div style="position: absolute;width: 100%;height: 100%;z-index:5;left: 0;">

            <!-- logo -->
            <div id="logo"></div>
            
            <!-- 中英文切换 -->
             <div id="language"></div>

            <div class="sw-login-main">
              <div class="sw-login-main-content">
                <div class="qrcode-button" @click="openOrCloseQrCode" v-if="config.qrCodeEnabled">
                  <div class="qrcode-button-img iconfont icon-banma" v-show="!isQrcode" :style="{color:`#${config.schemeColor}`}"> </div>
                  <div class="qrcode-button-img2 iconfont icon-bangediannao" v-show="isQrcode" :style="{color:`#${config.schemeColor}`}"></div>
                </div>
                <!-- 登录页 -->
                <div v-show="!isQrcode">
                  <el-menu @select="changeMenu" :default-active="currentMenu" class="sw-login-menu" text-color="#666" :active-text-color="`#${config.schemeColor}`" mode="horizontal">
                    <el-menu-item index="1" >{{i18n["cas.login.by.password"]||'账号密码登录'}}</el-menu-item>
                    <el-menu-item v-if="config.smsCodeEnabled" index="2" style="margin: 0 0 0 20px;">{{i18n["cas.login.by.sms"]||'手机动态码登录'}}</el-menu-item>
                  </el-menu>

                  <div v-show="currentMenu==1">
                    <div id="passwordLogin"></div>
                  </div>
                  <div v-show="currentMenu==2">
                    <div id="smsCodeLogin"></div>
                  </div>

                  <div  id="quickLink"></div>

                  <div id="federatedLogin"></div>
                </div>

                <!-- 扫码登录 -->
                <div v-show="isQrcode">
                  <div id="scanLogin"></div>
                </div>

                <div>
                  <div id="customLink"></div>
                  <div id="browserSupport"></div>
                  <div id="notice"></div>
                </div>
                

              </div>
            </div>

            <div id="announcement"></div>
            

          </div>
          <div id="noticeBoard"></div>
          <div id="copyright"></div>

        </el-container>
      </div>
    </div>
</template>

<script>
import '../font/iconfont.css' 
import {iconfont}  from '../font/iconfont.js' 
export default {
  props: [
    'i18n',
    'config',

    'isQrcode',
    'currentMenu',

  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
    console.log(this.smsCodeEnabled)
  },
  mounted: function mounted() {
    console.log('config',this.config)
  },
  methods:{
  }
}
</script>
